export default function RedCross() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.284 3.1629L10.3251 8.12183L15.284 13.0808L13.08 15.2847L8.12109 10.3258L3.16216 15.2847L0.958194 13.0808L5.91823 8.12072L0.958194 3.1629L3.16216 0.958931L8.1222 5.91675L13.08 0.958931L15.284 3.1629Z"
        fill="#FF5D6D"
      />
    </svg>
  );
}
